import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import img from '../../assets/images-sites/images.jpg';

const images = [
    { src: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=600", alt: "bible study" },
    { src: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=600", alt: "worship" },
];

const About = () => {
    const [imgIndex, setImgIndex] = useState(0);

    const prevImg = () => setImgIndex(i => (i === 0 ? images.length - 1 : i - 1));
    const nextImg = () => setImgIndex(i => (i === images.length - 1 ? 0 : i + 1));

    return (
        <section className="context-section py-5" id="qui-sommes-nous">
            <div className="container py-lg-5">

                {/* Contexte principal */}
                <div className="row g-5 align-items-center mb-5">
                    {/* Texte */}
                    <div className="col-lg-6 animate__animated animate__fadeInLeft">
                        <div className="context-content">
                            <span className="about-label text-uppercase fw-bold small mb-2 d-block">Qui sommes-nous</span>
                            <h2 className="context-title mb-4 outfit fs-1 fw-bold text-dark text-center text-lg-start">Contexte</h2>
                            <div className="context-text text-muted">
                                <p className="mb-3" style={{ fontSize: '0.93rem', lineHeight: '1.8' }}>
                                    L'église d'aujourd'hui est remplie des chrétiens qui sont dans l'effervescence et dans toute sorte d'agitation inutile et non dans l'essentiel. La Bible de nos jours est considérée comme un livre que seuls les prédicateurs doivent lire et interpréter pour les autres.
                                </p>
                                <p className="mb-3" style={{ fontSize: '0.93rem', lineHeight: '1.8' }}>
                                    Voilà pourquoi nous avons aujourd'hui des chrétiens déséquilibrés. Des chrétiens prêts à faire 21 jours de jeûne et prière mais incapables de passer 1h du temps à lire ou à méditer la Parole de Dieu.
                                </p>
                                <p className="fw-bold text-primary mb-4" style={{ fontSize: '0.93rem' }}>
                                    LAMP vient cependant pour créer l'équilibre entre la prière et la parole de Dieu.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Images : grille desktop, carousel mobile */}
                    <div className="col-lg-6 animate__animated animate__fadeInRight">
                        {/* ── Grille desktop (lg+) ── */}
                        <div className="context-image-grid-container d-none d-lg-block">
                            <div className="context-image-grid">
                                <div className="grid-stack-left">
                                    <div className="grid-img-item small-img mb-3">
                                        <img src={img} alt={img} className="rounded-4 w-100 h-100 object-cover" />
                                    </div>
                                    <div className="grid-img-item small-img">
                                        <img src={images[0].src} alt={images[0].alt} className="rounded-4 w-100 h-100 object-cover" />
                                    </div>
                                </div>
                                <div className="grid-tall-right">
                                    <div className="grid-img-item tall-img shadow-xl">
                                        <img src={images[1].src} alt={images[1].alt} className="rounded-4 w-100 h-100 object-cover" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ── Carousel mobile (< lg) : 1 image à la fois ── */}
                        <div className="about-img-carousel d-lg-none">
                            <div className="about-img-carousel-inner">
                                {images.map((img, idx) => (
                                    <div
                                        key={idx}
                                        className={`about-img-slide ${idx === imgIndex ? 'about-img-slide-active' : ''}`}
                                    >
                                        <img src={img.src} alt={img.alt} />
                                    </div>
                                ))}
                            </div>
                            {/* Contrôles */}
                            <button className="about-img-btn about-img-btn-prev" onClick={prevImg}>
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            <button className="about-img-btn about-img-btn-next" onClick={nextImg}>
                                <i className="bi bi-chevron-right"></i>
                            </button>
                            {/* Dots */}
                            <div className="about-img-dots">
                                {images.map((_, idx) => (
                                    <span
                                        key={idx}
                                        className={`about-img-dot ${idx === imgIndex ? 'active' : ''}`}
                                        onClick={() => setImgIndex(idx)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Vision & Mission */}
                <div className="row g-4 mt-2 mb-5">
                    <div className="col-md-6">
                        <div className="vm-card vision-card h-100">
                            <div className="vm-icon-wrap mb-3">
                                <i className="bi bi-eye-fill"></i>
                            </div>
                            <h3 className="vm-title fw-bold mb-2">Notre Vision</h3>
                            <p className="vm-text text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                Voir une génération de chrétiens profondément enracinés dans la Parole de Dieu, capables de discerner, de prier avec intelligence et de transformer leurs communautés par la lumière de l'Évangile.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="vm-card mission-card h-100">
                            <div className="vm-icon-wrap mb-3">
                                <i className="bi bi-bullseye"></i>
                            </div>
                            <h3 className="vm-title fw-bold mb-2">Notre Mission</h3>
                            <p className="vm-text text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                Rendre la méditation biblique accessible à tous les croyants à travers des ressources de qualité, des retraites spirituelles et une communauté engagée, afin que chaque enfant de Dieu grandisse dans sa foi.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Bouton En savoir plus */}
                <div className="text-center">
                    <Link to="/qui-sommes-nous" className="btn-en-savoir-plus">
                        En savoir plus <i className="bi bi-arrow-right ms-2"></i>
                    </Link>
                </div>

            </div>
        </section>
    );
};

export default About;
